// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"584":"ea41f630146b420caa5f","945":"c66f9b5dbefe44136534"}[chunkId] + ".js";
};